import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ padding: "2rem" }}>
    <Spinner animation="border" style={{ color: "#9061F9", width: "4rem", height: "4rem" }} />
  </div>
);

export default Loader;
